import { cn } from '@/lib/utils';
import { Pencil } from 'lucide-react';

export type EditPriceButtonProps = {
  price: string;
  onClick: () => void;
  className?: string;
};

export function EditPriceButton({ price, onClick, className }: EditPriceButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      onPointerDown={(e) => e.stopPropagation()}
      title="Click to edit price"
      aria-label={`Edit price $${price}`}
      className={cn(
        'group inline-flex h-6 max-w-full items-center gap-1 rounded-md border border-emerald-400/80 bg-white px-2 touch-manipulation',
        'text-[10px] font-semibold leading-none text-slate-700',
        'transition-colors hover:border-emerald-500 hover:bg-emerald-50/60 hover:text-emerald-800',
        'active:scale-[0.98]',
        className,
      )}
    >
      <span className="tabular-nums">${price}</span>
      <Pencil
        className="h-2.5 w-2.5 shrink-0 text-emerald-500 transition-colors group-hover:text-emerald-600"
        aria-hidden
      />
    </button>
  );
}
